<template>
 <v-layout column class="generic-dialog-layout" :class="classes">
   <v-layout
     align-center
     :justify-start="!$vuetify.breakpoint.mdAndUp"
     :justify-space-between="$vuetify.breakpoint.mdAndUp"
     class="dialog-header">

     <v-btn
       data-qa="dialog-close-button"
       class="dialog-close-button"
       @click="closeClicked"
       icon
       v-if="!$vuetify.breakpoint.mdAndUp"
     >
       <v-icon size="20">icon-back-16 {{$vuetify.rtl ? 'fa-rotate-180' : ''}}</v-icon>
     </v-btn>

    <div class="d-flex flex-row align-center justify-start dialog-title-container">
      <div class="dialog-title">{{headerText}}</div>
      <div class="post-title">
        <slot name="post-title"></slot>
      </div>
    </div>

     <div class="header-actions">
       <slot name="header-right-text">

       </slot>

       <v-btn
         data-qa="dialog-close-button"
         class="dialog-close-button"
         @click="closeClicked"
         icon
         v-if="$vuetify.breakpoint.mdAndUp"
       >
         <v-icon size="20">close</v-icon>
       </v-btn>
     </div>
   </v-layout>
   <v-layout :class="{'flex-column-reverse': !$vuetify.breakpoint.mdAndUp}" class="dialog-body">
     <v-layout class="left-side-pane">
       <slot name="left-side-pane">

       </slot>
     </v-layout>
     <v-layout v-if="displayRightPane" class="right-side-pane">
       <slot name="right-side-pane">

       </slot>
     </v-layout>
   </v-layout>
   <v-layout justify-end class="dialog-footer" v-if="!disableBottomCta">
     <v-btn
       class="dialog-btn cancel-button"
       data-qa="dialog-cancel-button"
       text
       @click="closeClicked"
       v-if="$vuetify.breakpoint.mdAndUp && isCancelBtnOn"
     >
       {{cancelButtonText || $t('common.dialog.cancel')}}
     </v-btn>
     <v-btn
       class="dialog-btn remove-button"
       data-qa="dialog-remove-button"
       text
       @click="removeClicked"
       v-if="isRemoveBtnOn"
     >
       {{ removeButtonText || $t('common.dialog.cancel')}}
     </v-btn>
     <v-btn
       class="dialog-btn submit-button"
       data-qa="dialog-submit-button"
       @click="submitClicked"
       v-if="isSubmitBtnOn"
       :disabled="isSubmitBtnDisabled"
       :loading="loading"
       :elevation="0"
       :block="!$vuetify.breakpoint.mdAndUp"
       :class="submitButtonClass"
       :color="brandBgColor">
       {{submitButtonText || $t('common.dialog.save')}}
     </v-btn>

   </v-layout>
 </v-layout>
</template>

<script>

  export default {
    components: {

    },
    props: {
      headerText: {
        type: String,
        required: true,
      },
      submitButtonText: {
        type: String
      },
      submitButtonClass: {
        type: String
      },
      isSubmitBtnOn: {
        type: Boolean,
        default: true
      },
      isSubmitBtnDisabled: {
        type: Boolean,
        default: false
      },
      isCancelBtnOn: {
        type: Boolean,
        default: true
      },
      disableBottomCta: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      cancelButtonText: {
        type: String,
      },
      displayRightPane: {
        type: Boolean,
        required: false,
        default: false,
      },
      classes: {
        type: String,
        required: false,
        default: ''
      },
      removeButtonText: {
        type: String
      },
      isRemoveBtnOn: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        loaderTimeOut: null
      }
    },
    watch: {
      loading: {
        handler(loading) {
          clearTimeout(this.loaderTimeOut)
          if (loading) {
            this.loaderTimeOut = setTimeout(() => {
              this.$emit('loader-time-out')
            }, this.LOADER_TIME_OUT)
          }
        }
      }
    },
    methods: {
      closeClicked() {
        this.$emit('close-dialog');
      },
      submitClicked(data) {
        this.$emit('submit-dialog', data)
      },
      removeClicked() {
        this.$emit('remove-clicked')
      }
    },
    computed: {
      brandBgColor() {
        return this.$store && this.$store.getters['brandModule/secondaryColor'];
      },
    },
    created() {
      this.LOADER_TIME_OUT = 20000

      const escapeHandler = (e) => {
        if (e.key === 'Escape') {
          this.closeClicked();
        }
      }

      document.addEventListener('keydown', escapeHandler);

      this.$once('hook:destroyed', () => {
        document.removeEventListener('keydown', escapeHandler);
      });
    }
  }
</script>

<style lang="scss">
  @import '@/assets/scss/abstract/_i18n-mixins';
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .generic-dialog-layout {
    scroll-snap-margin-top: 60px;
    scroll-snap-margin-bottom: 80px;
    scroll-margin-top: 60px;
    scroll-margin-bottom: 80px;
    position: relative;
    background-color: rgba(255, 255, 255);
    height: 100%;
    border-radius: 10px;
    margin: auto;
    font-family: var(--primary-font-family);
    @include md-and-up {
      padding-bottom: 0;
      height: unset;
    }

    .dialog-header {
      background-color: rgba(255, 255, 255);
      flex: 0;
      position: sticky;
      z-index: 7;
      top: 0;
      left: 0;
      border-radius: 10px 10px 0 0;
      @include i-padding(20px, 16px, 12px, 24px);
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      @include md-and-up {
        border-bottom: 1px solid $grey-color-7;
        @include i-padding(16px, 16px, 16px, 28px);
      }
      .post-title{
        margin-inline-start: 10px;
      }
      .dialog-title-container{
        width: 100%;
      }
      .dialog-title {
        color: rgba(0, 0, 0, 0.87);
        font-family: var(--primary-font-family);
        font-size: 17px;
        font-weight: bold;

        @include md-and-up {
          line-height: 24px;
          margin: 0;
        }
      }
      .header-actions {
        @include i-text-align(right);
      }
      .cancel-button {
        padding: 0;

      }
    }

    .left-side-pane {
      padding: 12px 25px;
      flex-basis: 100%;
      background-color: var(--modal-bg-color);
      height: 100%;
      border-top: 1px solid rgba(0, 0, 0, 0.12);
      @include md-and-up {
        min-height: 100%;
        padding: 20px 28px;
        max-width: -moz-min-content;
        max-width: fit-content;
        border-top: unset;
      }
    }
    .right-side-pane {
      padding: 12px 25px;
      min-width: 100%;
      height: auto;
      flex: 0;
      @include md-and-up {
        min-height: 100%;
        padding: 20px 28px;
        min-width: unset;
        border: 0;
        @include i-border-left(1px solid $grey-color-7);
        flex: 1 1 auto;
      }
    }
    .dialog-footer {
      z-index: 7;
      width: 100%;
      background-color: rgba(255, 255, 255);
      bottom: 0;
      left: 0;
      position: fixed;
      padding: 12px 16px;
      // On mobile this footer is fixed to the viewport bottom, so the OS navigation bar /
      // home indicator overlaps its Save/Cancel buttons (e.g. Android 3-button nav). Add the
      // safe-area inset to the bottom padding so the buttons clear it and the footer's white
      // background fills to the edge. --safe-area-inset-bottom is injected into this iframe by
      // the shell (env() is 0 here) and resolves to 0 off-device. On desktop (md-and-up) the
      // footer is sticky in a centered dialog, so no inset is needed (padding is reset below).
      padding-bottom: calc(12px + var(--safe-area-inset-bottom, 0px));
      border-top: 1px solid $grey-color-7;
      flex: 0;
      border-radius: 0 0 10px 10px;
      @include md-and-up {
        padding: 16px 28px;
        position: sticky;
      }
      .cancel-button {
        margin: 0 10px;
      }
      .remove-button {
        margin-inline-start: 0;
        padding: 0;
        margin-inline-end: 10px;

        flex: 1;

        &~.submit-button {
          max-width: calc((100% / 2) - 5px);
          min-width: unset !important;
        }

        @include md-and-up {
          flex: revert;

          &~.submit-button {
            max-width: revert;
            min-width: revert !important;
          }
        }
      }
      .submit-button {
        color: #ffffff;
        font-size: 17px;

        @include md-and-up {
          font-size: 14px;
          &.vcita-medium-button {
            min-height: 40px;
          }
        }
      }
    }
      .dialog-close-button {
      @include i-position-mirror(left, 5px);
      max-height: 24px;
      max-width: 24px;
    }

    .dialog-btn {
      font-family: var(--primary-font-family);
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      min-height: 40px;
      height: 40px;
      line-height: 2.67;
      color: #0c315e;
      text-transform: unset;
      font-weight: 600;
      letter-spacing: normal;

      .v-btn__content {
        margin: 0 10px;
      }
  }

}
</style>
